<div class="contact-document-row">
    <div class="document-container" *ngFor="let document of documents">
        <div (click)="openDocument(document);" matTooltip="{{document.templateName}}" class="document-icon" [ngClass]="{'document-icon-pdf' : document.type == 'pdf'}">
            <fa-icon *ngIf="document.type == 'pdf'" [icon]="['fas','file-pdf']" size="lg"></fa-icon>
            <fa-icon *ngIf="document.type == 'png' || document.type == 'jpg' || document.type == 'jpeg'" [icon]="['fas','file-image']" size="lg"></fa-icon>
        </div>
        <div class="document-request">
            <div *ngIf="document.requestRead">
                <fa-icon [icon]="['fas','check']" size="lg"></fa-icon>
            </div>
        </div>
        <div class="document-request">
            <div *ngIf="type == 'RX'" (click)="sendRXSMS(document)" class="document-sms">
                <fa-icon [icon]="['far','sms']" size="lg"></fa-icon>
            </div>
        </div>
    </div>
</div>